const DEPRECATED_PROP_MESSAGES = {
    size: 'Use `size` prop instead.',
    width: 'Use `width` prop instead.',
    accessibleText: 'Use `accessibleText` prop instead.',
    noReplacement: 'This prop is no longer supported and there is no replacement.',
    pattern: 'Use a pattern of other SWAN components instead.'
};

export { DEPRECATED_PROP_MESSAGES };
